export default __webpack_public_path__ + "static/media/clock.57c6c084.svg";